import KueskiPusher from './KueskiPusher';

const onBackendNotification = (args) => {
  KueskiPusher.getPusherChannel().then((channel) => {
    channel.bind(args.pusherEvent, args.callback);
  });
};

export default onBackendNotification;
